/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OperatoreCreateDTO
 */
export interface OperatoreCreateDTO {
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    enteId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    cognome?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    codiceFiscale?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    regioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    provinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    comuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    regione?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    provincia?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    comune?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof OperatoreCreateDTO
     */
    cellulare?: string;
}

/**
 * Check if a given object implements the OperatoreCreateDTO interface.
 */
export function instanceOfOperatoreCreateDTO(value: object): value is OperatoreCreateDTO {
    return true;
}

export function OperatoreCreateDTOFromJSON(json: any): OperatoreCreateDTO {
    return OperatoreCreateDTOFromJSONTyped(json, false);
}

export function OperatoreCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatoreCreateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'enteId': json['enteId'] == null ? undefined : json['enteId'],
        'nome': json['nome'] == null ? undefined : json['nome'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'codiceFiscale': json['codiceFiscale'] == null ? undefined : json['codiceFiscale'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'regioneId': json['regioneId'] == null ? undefined : json['regioneId'],
        'provinciaId': json['provinciaId'] == null ? undefined : json['provinciaId'],
        'comuneId': json['comuneId'] == null ? undefined : json['comuneId'],
        'regione': json['regione'] == null ? undefined : json['regione'],
        'provincia': json['provincia'] == null ? undefined : json['provincia'],
        'comune': json['comune'] == null ? undefined : json['comune'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
    };
}

export function OperatoreCreateDTOToJSON(value?: OperatoreCreateDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enteId': value['enteId'],
        'nome': value['nome'],
        'cognome': value['cognome'],
        'codiceFiscale': value['codiceFiscale'],
        'nazioneId': value['nazioneId'],
        'regioneId': value['regioneId'],
        'provinciaId': value['provinciaId'],
        'comuneId': value['comuneId'],
        'regione': value['regione'],
        'provincia': value['provincia'],
        'comune': value['comune'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
    };
}

